import axiosInstance from '../utils/axios-instance';
import {actionCreator, createRequestTypes, getErrorMessage} from '../utils/helpers';
import {PAYMENT_PROVIDER_FIND_ALL_IDS} from "./paymentProvider.actions";

export const MAPPING_SYSTEM_FIND_PROVIDER_BY_ID = createRequestTypes('@mappingSystem/FIND_PROVIDER_BY_ID');
export const MAPPING_SYSTEM_PATCH_PROVIDER = createRequestTypes('@mappingSystem/PATCH_PROVIDER');
export const MAPPING_SYSTEM_CURRENT_ID = createRequestTypes('@mappingSystem/CURRENT_ID');
export const MAPPING_SYSTEM_ALL_PROVIDERS = createRequestTypes('@mappingSystem/ALL_PROVIDERS');
export const MAPPING_SYSTEM_ALL_PROVIDERS_IDS = createRequestTypes('@mappingSystem/ALL_PROVIDERS_IDS');
export const WORKFORCE_FIND_PROVIDER_BY_ID = createRequestTypes('@workforce/FIND_PROVIDER_BY_ID');
export const WORKFORCE_PATCH_PROVIDER_ID = createRequestTypes('@workforce/PATCH_PROVIDER_ID');
export const WORKFORCE_FIND_CURRENT_PROVIDER_ID = createRequestTypes('@workforce/FIND_CURRENT_PROVIDER_ID');
export const WORKFORCE_FIND_ALL_PROVIDERS = createRequestTypes('@workforce/FIND_ALL_PROVIDERS');
export const WORKFORCE_ALL_PROVIDERS_IDS = createRequestTypes('@workforce/ALL_PROVIDERS_IDS');


//getting providers


export const getMappingSystemProviderById = (mappingProviderId) => async (dispatch) => {
    dispatch(actionCreator.request(MAPPING_SYSTEM_FIND_PROVIDER_BY_ID));
    try {
        const response = await axiosInstance.get(`/mapping-system/${mappingProviderId}`);

        dispatch(actionCreator.success(MAPPING_SYSTEM_FIND_PROVIDER_BY_ID, response.data));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(MAPPING_SYSTEM_FIND_PROVIDER_BY_ID, getErrorMessage(err)));

        throw err;
    }
}


export const getMappingSystemCurrentId = () => async (dispatch) => {
    dispatch(actionCreator.request(MAPPING_SYSTEM_CURRENT_ID));
    try {
        const response = await axiosInstance.get(`/mapping-system/current/id`);

        dispatch(actionCreator.success(MAPPING_SYSTEM_CURRENT_ID, response.data.id));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(MAPPING_SYSTEM_CURRENT_ID, getErrorMessage(err)));

        throw err;
    }
}


export const getMappingSystemAllProviders = () => async (dispatch) => {
    dispatch(actionCreator.request(MAPPING_SYSTEM_ALL_PROVIDERS));
    try {
        const response = await axiosInstance.get(`/mapping-systems`);

        dispatch(actionCreator.success(MAPPING_SYSTEM_ALL_PROVIDERS, response.data.id));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(MAPPING_SYSTEM_ALL_PROVIDERS, getErrorMessage(err)));

        throw err;
    }
}


export const getMappingSystemAllProviderIDS = () => async (dispatch) => {
    dispatch(actionCreator.request(MAPPING_SYSTEM_ALL_PROVIDERS_IDS));
    try {
        const response = await axiosInstance.get(`/mapping-systems/id`);

        dispatch(actionCreator.success(MAPPING_SYSTEM_ALL_PROVIDERS_IDS, response.data.ids));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(MAPPING_SYSTEM_ALL_PROVIDERS_IDS, getErrorMessage(err)));

        throw err;
    }
}


export const getWorkforceProviderByID = (providerId) => async (dispatch) => {
    dispatch(actionCreator.request(WORKFORCE_FIND_PROVIDER_BY_ID));
    try {
        const response = await axiosInstance.get(`/workforce/map/${providerId}`);

        dispatch(actionCreator.success(WORKFORCE_FIND_PROVIDER_BY_ID, response.data));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(WORKFORCE_FIND_PROVIDER_BY_ID, getErrorMessage(err)));

        throw err;
    }
}


export const getWorkforceCurrentProviderID = () => async (dispatch) => {
    dispatch(actionCreator.request(WORKFORCE_FIND_CURRENT_PROVIDER_ID));
    try {
        const response = await axiosInstance.get(`/workforce/map/current/id`);

        dispatch(actionCreator.success(WORKFORCE_FIND_CURRENT_PROVIDER_ID, response.data.id));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(WORKFORCE_FIND_CURRENT_PROVIDER_ID, getErrorMessage(err)));

        throw err;
    }
}

export const getWorkforceAllProviders = () => async (dispatch) => {
    dispatch(actionCreator.request(WORKFORCE_FIND_ALL_PROVIDERS));
    try {
        const response = await axiosInstance.get(`/workforce/maps`);

        dispatch(actionCreator.success(WORKFORCE_FIND_ALL_PROVIDERS, response.data.id));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(WORKFORCE_FIND_ALL_PROVIDERS, getErrorMessage(err)));

        throw err;
    }
}

export const getWorkforceAllProvidersIDS = () => async (dispatch) => {
    dispatch(actionCreator.request(WORKFORCE_ALL_PROVIDERS_IDS));
    try {
        const response = await axiosInstance.get(`/workforce/maps/id`);

        dispatch(actionCreator.success(WORKFORCE_ALL_PROVIDERS_IDS, response.data.ids));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(WORKFORCE_ALL_PROVIDERS_IDS, getErrorMessage(err)));

        throw err;
    }
}



//setting current providers


export const setMappingSystemProvider = (mappingProviderId) => async (dispatch) => {
    dispatch(actionCreator.request(MAPPING_SYSTEM_FIND_PROVIDER_BY_ID));
    try {
        const response = await axiosInstance.put(`/mapping-system/current/${mappingProviderId}`);

        dispatch(actionCreator.success(MAPPING_SYSTEM_FIND_PROVIDER_BY_ID, mappingProviderId));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(MAPPING_SYSTEM_FIND_PROVIDER_BY_ID, getErrorMessage(err)));

        throw err;
    }
}


export const setCurrentWorkforce = (providerId) => async (dispatch) => {
    dispatch(actionCreator.request(WORKFORCE_FIND_PROVIDER_BY_ID));
    try {
        const response = await axiosInstance.patch(`/workforce/map/current/${providerId}`);

        dispatch(actionCreator.success(WORKFORCE_FIND_PROVIDER_BY_ID, providerId));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(WORKFORCE_FIND_PROVIDER_BY_ID, getErrorMessage(err)));

        throw err;
    }
}



//clear providers


export const clearCurrentWorkforceProviderId = () => (dispatch) => {
    dispatch(actionCreator.empty(WORKFORCE_FIND_PROVIDER_BY_ID));
}

export const clearWorkforceAllIds = () => (dispatch) => {
    dispatch(actionCreator.empty(WORKFORCE_ALL_PROVIDERS_IDS));
}

export const clearWorkforceProviderIds = () => (dispatch) => {
    dispatch(actionCreator.empty(WORKFORCE_ALL_PROVIDERS_IDS));
}

export const clearMappingProviderId = () => (dispatch) => {
    dispatch(actionCreator.empty(MAPPING_SYSTEM_FIND_PROVIDER_BY_ID));
}

export const clearMappingAllIds = () => (dispatch) => {
    dispatch(actionCreator.empty(MAPPING_SYSTEM_ALL_PROVIDERS));
}

export const clearMappingProviderIds = () => (dispatch) => {
    dispatch(actionCreator.empty(MAPPING_SYSTEM_ALL_PROVIDERS_IDS));
}


// patching providers

export const patchMappingSystem = (mappingProviderId, providerPatch) => async (dispatch) => {
    dispatch(actionCreator.request(MAPPING_SYSTEM_PATCH_PROVIDER));
    try {
        const response = await axiosInstance.patch(`/mapping-system/${mappingProviderId}`, providerPatch);

        dispatch(actionCreator.success(MAPPING_SYSTEM_PATCH_PROVIDER, response.data));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(MAPPING_SYSTEM_PATCH_PROVIDER, getErrorMessage(err)));

        throw err;
    }
}


export const patchWorkforce = (providerId, providerPatch) => async (dispatch) => {
    dispatch(actionCreator.request(WORKFORCE_PATCH_PROVIDER_ID));
    try {
        const response = await axiosInstance.patch(`/workforce/map/${providerId}`, providerPatch);

        dispatch(actionCreator.success(WORKFORCE_PATCH_PROVIDER_ID, response.data));

        return response;
    } catch (err) {
        dispatch(actionCreator.failure(WORKFORCE_PATCH_PROVIDER_ID, getErrorMessage(err)));

        throw err;
    }
}

